import { createTheme } from "@mui/material/styles";

export const getTheme = (mode) => {
    const mainPalette = mode === "dark" ? "#2B343A" : "#2B343A";
    const bluePalette = mode === "dark" ? "#1976d2" : "#1976d2"; // Bluer than #2B343A

    // Darker shade of #1976d2 for hover: #115293
    return createTheme({
        homeAppBar: {
            backgroundColor: mainPalette,
            maxWidth: "100% !important",
            width: "100%",
        },
        container: {
            backgroundColor: mode === "dark" ? "#1e1e1e" : "#F6F6F6",
            maxWidth: "100% !important",
            width: "100%",
            minHeight: "100vh",
        },
        palette: {
            mode: mode,
            primary: {
                main: mode === "dark" ? "#b3b3b3" : mainPalette,
                chartPoint: mode === "dark" ? "#FFFFFF" : mainPalette,
            },
            background: {
                mainPalette,
                default: mode === "dark" ? "#161618" : "#ffffff",
                paper: mode === "dark" ? "#1e1e1e" : "#ffffff",
            },
            text: {
                primary: mode === "dark" ? "#ffffff" : "#000000",
                secondary: mode === "dark" ? "#cccccc" : "#666666",
            },
            color: {
                main: mainPalette,
                icon: mode === "dark" ? "#ffffff" : mainPalette,
                button: mode === "dark" ? "#ffffff" : mainPalette,
            },
            backgroundColor: {
                main: mainPalette,
                transparent: "transparent",
                navbarSelected: mode === "dark" ? "lightgray" : "lightgray",
            },
            tabSelected: {
                main: mode === "dark" ? "#ffffff" : mainPalette,
            },
        },
        tinyMCE: {
            skin: mode === "dark" ? "oxide-dark" : "oxide",
            content_css: mode === "dark" ? "dark" : "default",
        },
        toggleButtonGroup: {
            selected: {
                main: "#115293 !important",
                color: "#ffffff !important",
            },
            hover: {
                main: "#1976d2 !important",
                color: "#ffffff !important",
            },
        },
    });
};
